export function fmt(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? iso : d.toLocaleString();
}

export function short(id: string | null | undefined): string {
  return id ? id.slice(0, 8) : "—";
}

/** Human duration from seconds: "45s" / "6m" / "1.2h". Null/undefined → em-dash. */
export function fmtDuration(sec: number | null | undefined): string {
  if (sec == null) return "—";
  if (sec < 60) return `${Math.round(sec)}s`;
  if (sec < 3600) return `${Math.round(sec / 60)}m`;
  return `${(sec / 3600).toFixed(1)}h`;
}

/**
 * Compact duration from MILLISECONDS — the "last collect" figure in the scraper panel. Sub-second
 * stays in ms, then one-decimal seconds under 10s, whole seconds under a minute, then "Xm Ys".
 */
export function fmtMillis(ms: number): string {
  if (ms < 1000) return `${Math.round(ms)}ms`;
  const s = ms / 1000;
  if (s < 60) return `${s.toFixed(s < 10 ? 1 : 0)}s`;
  const m = Math.floor(s / 60);
  const rem = Math.round(s % 60);
  return rem ? `${m}m ${rem}s` : `${m}m`;
}
